import type { FC } from 'react';

type PreviewLayoutProps = {
  chart: React.ReactNode;
  table: React.ReactNode;
  link: React.ReactNode;
};

export const PreviewLayout: FC<PreviewLayoutProps> = ({
  chart,
  table,
  link,
}) => (
  <div className="flex flex-col gap-6">
    {/* Main area -------------------------------------------------- */}
    <div className="grid w-full auto-rows-fr grid-cols-1 gap-6 px-2 pt-20 md:grid-cols-[2fr_3fr]">
      {chart}
      {table}
    </div>
    {/* Link area -------------------------------------------------- */}
    <div className="sticky bottom-4 flex justify-center">{link}</div>
  </div>
);
